import type { FaireProductEntity } from "../../entity_types/product";

export const p_cw2r7xjaga: FaireProductEntity = {
  token: "p_cw2r7xjaga",
  type: "product",
  name: "🧿 Magnesium Bath Bomb for Relaxation, Recovery, Sleep",
  brandToken: "b_83y6fhr0",
  brandName: "Latika Beauty",
  imageUrl:
    "https://cdn.faire.com/fastly/1d5226bdf4eb9904d4c90e4376ad155feacaf187fcbb516f231cf909cdcf3efb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1d48671b62fb9259d9aa064c3fd71005fb872ca043447db1dc1e95366b70adf0.webp",
    "https://cdn.faire.com/fastly/46c308b08cf0bb3e49c6829cc541ca9a74abfed4b1c8573dc925ac720ccf7b75.jpeg",
    "https://cdn.faire.com/fastly/de534d029df6727da7d786d6fa9923876c278fe25fb62c6ec7c8b7ea4157403c.jpeg",
    "https://cdn.faire.com/fastly/708abf747f0ea24a3934c2272088ede4efb5f4768ea4f048c46a68fae6ce0a0d.jpeg",
    "https://cdn.faire.com/fastly/5d81b017e9d31a4b146462c747106a6d98c4c77f611a38d5f1eb1318e9066a62.jpeg",
    "https://cdn.faire.com/fastly/e6b6e9372724f38926bdbd4b4dd85d28c0e8871600437ef378d53532195e50a1.jpeg",
    "https://cdn.faire.com/fastly/3cdb0efe3b646567e1760d56aaadcf757400e5b836afe88e2abbd4dcde74b6d1.png",
  ],
  priceDollars: 5,
  description:
    "🔵 Luxurious magnesium bath bomb infused with pure magnesium chloride and calming lavender essential oil, designed to help ease muscle tension, support recovery, and promote restful sleep. \n\nPerfect for self-care, athletic recovery, or stress-relief gifts during the holidays and beyond.\n\n🔵 Benefits:\n• Transdermal Magnesium   Absorbs through the skin to replenish magnesium naturally.\n• Relax & Recover>: Soothes sore muscles and calms the body before bed.\n• Moisturizing Care > Signature five-oil blend leaves skin soft and nourished.\n• Clean Ingredients  High-quality natural oils and essential minerals.\n• Gift-Ready: > Ideal for wellness rituals, relaxation, or magnesium bath therapy.\n\n🔵 Collection Note > Discover the complete Magnesium Collection by Latika - including Oil, Balm, Cream, Soak, and Bath Bomb.",
  tags: [],
  msrpDollars: 10,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:54:06.864Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
